import { useUserStore } from '@/config/store/userStore'

export const canUseAiAssistant = () => {
  const userStore = useUserStore()
  return !!userStore.user?.profile?.modules?.aiAssistant?.isAccess
}
